
import ProjectSection from '../components/ProjectSection'

export default function Projects() {
  return (
    <div>
      <ProjectSection />
    </div>
  )
}
